module.exports = __webpack_public_path__ + "static/media/scheduled.300838da.xlsx";